module.exports = __webpack_public_path__ + "resources/img/equipment_tab2_img_m.03383cb3f0016471d5bbcae7a40aacbc.jpg";